<template>
  <div>
    <v-container>
      <div style="display: flex">
        <h3 class="headline">{{ $t('total_users') }}</h3>
        <a
          href="https://tinyurl.com/y2mprzbr"
          target="blank"
          style="align-self: center; margin-left: 6px; margin-bottom: 4px"
          ><i style="font-size: 18px; color: #ff706b" class="fas fa-question-circle"></i
        ></a>
      </div>
      <total-users></total-users>
    </v-container>
    <v-divider />
    <v-container>
      <h3 class="headline">{{ $t('new_users') }}</h3>
      <new-users></new-users>
    </v-container>
  </div>
</template>

<script>
import TotalUsers from './TotalUsers'
import NewUsers from './NewUsers'
export default {
  components: {
    TotalUsers,
    NewUsers
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/Overview.vue